import type { IconNames } from '@dixa/lib-shared-habla';

import { FlowNode, flowNodeColor, NodeTypeComponent } from 'fable/flowEditor';
import type { NodeT } from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';

import { noModal } from '../modals';
import type { AutomationFlowExtraDataT } from '../types';

export type AutomationNodeClosePayloadT = {};
export type AutomationNodeCloseTypeT = AutomationNodeTypes.CLOSE;
export type AutomationNodeCloseT = NodeT<
  AutomationNodeCloseTypeT,
  AutomationNodeClosePayloadT
>;

export class CloseNode extends NodeTypeComponent<
  AutomationNodeCloseT,
  AutomationFlowExtraDataT
>() {
  static icon: IconNames = 'close-circle-filled';
  static label = 'Close conversation';
  static color = flowNodeColor.red;
  static helpText =
    'Close the conversation entirely when it matches predetermined criteria (e.g. after a filter or tag is applied, after an auto-reply is sent, etc.). Note that once the conversation is closed, it will not be sent to a queue or agent.';
  static ActionModal = noModal<AutomationNodeCloseT>(AutomationNodeTypes.CLOSE);
  static actionTrigger = { type: AutomationNodeTypes.CLOSE };
  static updateConnection = (
    node: AutomationNodeCloseT,
  ): AutomationNodeCloseT => {
    return node;
  };

  render() {
    return (
      <FlowNode
        color={CloseNode.color}
        icon={CloseNode.icon}
        label={CloseNode.label}
      />
    );
  }
}
